import config from "../config"
import { User } from "./user/user"

export class API {
	public static readonly USER = new User(config.app.api, "/v1/user")
}
